import React , {useContext} from "react";
import Editor from "./Editor";
import { Box , styled } from "@mui/material";
import { DataContext } from "../context/DataProvider";

const Container = styled(Box)`
    display : flex;
    background-color : #060606
`

const Code = () => {

    const {html , setHtml , css , setCss , js , setJs} = useContext(DataContext);

    return (
        <Container>
            <Editor heading = "Html" color="#D21312" value={html} onChange={setHtml} />
            <Editor heading = "Css" color="#27E1C1" value={css} onChange={setCss} />
            <Editor heading = "Javascript" color="#FFD93D" value={js} onChange={setJs} />
        </Container>
    )
}

export default Code;